import { create } from "zustand";

export const useVideoPlayerStore = create((set) => ({
  muted: true,
  playing: true,
  mute: () => set(() => ({ muted: true })),
  unMute: () => set({ muted: false }),
  play: () => set({ playing: true }),
  unPlay: () => set({ playing: false }),
}));
